export const SESSIONSTORAGE = {
  trackingAlertDisplayed: '__sandbox_tracking_alert_displayed_storage__',
  canViewAllDataAlert: '__sandbox_can_view_all_data_alert_storage__',
  firstKwSessionSearch: '__sandbox_keyword_session_storage'
};

export default SESSIONSTORAGE;
